import { Anchor, Button, Container, Image, Text, Title } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { getKitabaBook } from '@/entities/books/api/admin-books-api';
import { Book } from '@/entities/books/model/types';
import { useProjectPath } from '@/shared/projects/project-path';

import styles from './kitaba-book-description.module.scss';

export function KitabaBookDescription() {
  const { bookId } = useParams();
  const navigate = useNavigate();
  const withProject = useProjectPath();
  const [book, setBook] = useState<Book | null>(null);

  useEffect(() => {
    if (!bookId) return;
    getKitabaBook(bookId)
      .then(setBook)
      .catch(() => {
        notifications.show({
          message: 'Не удалось загрузить книгу',
          color: 'red',
        });
      });
  }, [bookId]);

  if (!book) return <Container mt={50}>Загрузка...</Container>;

  const details = [
    ['Автор', book.author || 'Не выбран'],
    ['Категории', book.categoryTitles?.join(', ') || 'Не выбраны'],
    ['Издательство', book.publisherTitle || 'Не выбрано'],
    ['Переводчик', book.translatorName || 'Не указан'],
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <main className={styles.main}>
          <Title className={styles.title}>{book.title}</Title>
          <Text className={styles.description}>
            {book.description || 'Описание не указано'}
          </Text>

          <dl className={styles.details}>
            {details.map(([label, value]) => (
              <div className={styles.detailRow} key={label}>
                <Text component="dt" className={styles.term}>
                  {label}
                </Text>
                <Text component="dd" className={styles.value}>
                  {value}
                </Text>
              </div>
            ))}
          </dl>

          <div className={styles.actions}>
            {book.fileUrl ? (
              <Anchor href={book.fileUrl} target="_blank" rel="noreferrer">
                Открыть EPUB
              </Anchor>
            ) : (
              <Text c="dimmed">EPUB не загружен</Text>
            )}
            <Button onClick={() => navigate(withProject(`/books/${book.id}`))}>
              Редактировать книгу
            </Button>
          </div>
        </main>

        <aside className={styles.coverColumn}>
          <div
            className={`${styles.status} ${
              book.isPublished ? styles.published : styles.draft
            }`}
          >
            {book.isPublished ? 'Опубликовано' : 'Черновик'}
          </div>
          <Image
            src={book.imgUrl}
            fallbackSrc="/book-cover-placeholder.svg"
            alt={`Обложка книги «${book.title}»`}
            className={styles.cover}
          />
        </aside>
      </div>
    </div>
  );
}
